<template>
	<div class="banner6">
		<div id="" class="banner_logo">
			<div class="logo_title">
				<img src="../../assets/logo.png" >
<!-- 				<img class="banner1_logo banner1_logo_left" src="../../assets/logo/lo.png" >
				<img class="banner1_logo banner1_logo_right" src="../../assets/logo/ro.png" >
				Gamehaus
				<span class="logo_title_icon"></span> -->
			</div>
		</div>
		<div id="" v-if="$i18n.locale == 'en'">
			<div id="" class="banner1_text en">
				<span>See</span>
				 <span>our</span>
				 <div @click="gotoPage(7)" style="display: inline-block; position: relative; cursor: pointer;">Games<span :class="curpage == 6 ? 'borderspan1 borderspan1Ani' : 'borderspan1'"></span></div>
				
			</div>
			<div id="" class="banner1_text en">
				<span @click="gotoPage(8)" style="display: inline-block; position: relative; cursor: pointer;">Contact<span :class="curpage == 6 ? 'borderspan2 borderspan2Ani' : 'borderspan2'"></span></span>
				<span>us</span>
				<span>now</span>
			</div>
		</div>
		<div id="" v-if="$i18n.locale == 'cn'">
			<div id="" class="banner1_text">
				<span>探索更多</span>
				 <!-- <span>our</span> -->
				 <span @click="gotoPage(7)" style="display: inline-block; position: relative;cursor: pointer;">游戏<span :class="curpage == 6 ? 'borderspan1cn borderspan1cnAni' : 'borderspan1cn'"></span></span>
				
			</div>
			<div id="" class="banner1_text">
				<div @click="gotoPage(8)" style="display: inline-block; position: relative;cursor: pointer;">联系<span :class="curpage == 6 ? 'borderspan2 borderspan2Ani' : 'borderspan2'"></span></div>
				<span>我们</span>
				<!-- <span>now</span> -->
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: ['curpage'],
		data () {
			return {
			}
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					// console.log(newvalue)
				}
			}
		},
		methods: {
			gotoPage (page) {
				// console.log(page, '点击')
				this.$emit('goPage', page)
			}
		}
	}
</script>

<style lang="scss">
	.banner6 {
		height: 100vh;
		// background-image: url('../../assets/bg.jpg');
		background-repeat:no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		padding: 2.575rem 1.25rem;
		padding-left: 1.5625rem;
		.logo_title {
			width: 6rem;
			margin-top: 2rem;
			margin-bottom: 0.7rem;
			img {
				display: inline-block;
				width: 100%;
			}
		}
		.logo_desc_sub {
			font-size: 0.225rem;
			font-weight: 700;
			color: #fff;
		}
		.banner1_text {
			-webkit-text-stroke: 1px #000;  
			-webkit-text-fill-color : transparent;
			font-family: 'PilatTest-Bold';
			// src: url("/assets/PilatTest-Bold.otf") format("otf");
			font-size: 1.375rem; 
			font-weight: 700;
			position: relative;
			width: 100%;
			.borderspan1 {
				width: 95%;
				display: block;
				border: 1px solid #000000;
				border-radius: 3px;
				height: 8px;
				position: absolute;
				// right: -5px;
			}
			.borderspan1cn {
				width: 95%;
				display: block;
				border: 1px solid #000;
				border-radius: 3px;
				height: 8px;
				position: absolute;
			}
			.borderspan1Ani {
				animation: borderspan1_ani 2s;
			}
			.borderspan1cnAni {
				animation: borderspan1cn_ani 2s;
			}
			.borderspan2 {
				width: 95%;
				display: block;
				border: 1px solid #000;
				border-radius: 3px;
				height: 8px;
				position: absolute;
			}
			.borderspan2Ani {
				animation: borderspan2_ani 2s;
			}
		}
		.en {
			span {
				margin-right: 0.4125rem;
			}
		}
	}
	@keyframes borderspan1_ani {
		0% {
			left: 0;
		}
		50% {
			left: -120%;
		}
		100% {
			left: 0;
		}
	}
	@keyframes borderspan1cn_ani {
		0% {
			left: 0;
		}
		50% {
			left: -180%;
		}
		100% {
			left: 1%;
		}
	}
	
	@keyframes borderspan2_ani {
		0% {
			left: 0;
		}
		50% {
			left: 100%;
		}
		100% {
			left: 0;
		}
	}
</style>
